import styled from 'styled-components';
import {mobileMedia, scrollbar} from '../../globalVariables/GlobalVariables';
import {dFlexCenter, dFlexBetween, dFlexEnd, dFlex, flexColumn, alignEnd, justifyCenter, justifyEvenly, alignStart, justifyEnd} from '../../globalVariables/GlobalFlex';
import zIndex from '../../globalVariables/zIndex';
import {getFontSize, getFontWeight, getToken, getPrimitive, getSpacing, responsive} from '@tickchak/react-share/app';

export const wrap = styled.div`
    padding: 20px;
    padding-top: 10px;
    width: 100%;
    height: calc(100% - 60px);
    display: ${dFlex};
    ${flexColumn}
    ${mobileMedia} {
        padding: 10px;
    }
`;

export const headerItems = styled.div`
    ${dFlexEnd}
    height: 100%;
    padding: 10px 0;
    
    ${mobileMedia} {
        margin-bottom: 10px;
        padding: 5px 0;
    }
`;

export const stepper = styled.div`
    width: 100%;
    height: max-content;
    position: relative;
    // padding-bottom: 20px;
    ${mobileMedia} {
        // padding-bottom: 15px;
    }
`;

export const stepperLine = styled.div`
    position: relative;
    top: calc(50% - 18px);
    height: 2px;
    width: 100%;
    display: ${dFlex};
    z-index: 0; /* behind circles */
`;

export const stepSegment = styled.div`
    flex: 1;
    background: ${getPrimitive('blackAlphas.black30')}; /* gray for step */

    &.current{
        background: ${getToken('color.brand.main')}; /* blue for current step */
    }
    &.complete{
        background: ${getPrimitive('greens.green400')}; /* green for complete step */
    }
    &.toCurrent{
        background: linear-gradient(90deg, ${getToken('color.brand.main')} 0%, ${getPrimitive('greens.green400')} 100%);
    }
`;

export const steps = styled.div`
    position: relative;
    height: 70px;
    ${dFlex}
    ${justifyEvenly}
    ${alignStart}
    width: 100%;
    z-index: ${zIndex.baseRaised};
`;

export const step = styled.div`
    cursor: pointer;
    flex: 1;
    height: max-content;
    text-align: center;
    position: relative;
    ${dFlex}
    ${alignEnd}
    ${justifyCenter}
    &.disabled{
        cursor: default;
        pointer-events: none;
    }
`;

export const stepContent = styled.div`
    ${dFlexCenter}
    ${flexColumn}
    gap: 6px;
`;

export const iconCircle = styled.div`
    ${dFlexCenter}
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: ${getToken('color.bg.base')};
    border: 1.5px solid ${getPrimitive('blackAlphas.black30')};
    position: relative;
    z-index: 1; /* ensure circles above the line */

    /* current */
    .current & {
        background: ${getPrimitive('turquoise.turquoise100')};
        border-color: ${getPrimitive('turquoise.turquoise400')};
    }

    /* complete/passed */
    .complete & {
        background: ${getPrimitive('greens.green50')};
        border-color: ${getPrimitive('greens.green400')};
    }
`;

export const stepLabel = styled.div`
    font-size: ${getFontSize('caption')};
    font-weight: ${getFontWeight('medium')};
    color: ${getPrimitive('blackAlphas.black70')};
    white-space: pre-line;
    ${mobileMedia} {
        font-size: ${getFontSize('xs', 'mobile')};
    }

`;

export const body = styled.div`
    flex: 1;
    ${responsive(getSpacing('spaceXl'), 'padding')};
    ${scrollbar};
    margin-bottom: 20px;
    ${mobileMedia} {
        margin-bottom: 15px;
        padding: ${getSpacing('spaceSm')};
    }
`;

export const footer = styled.div`
    ${dFlexBetween}
    gap: 10px;
    padding-top: 20px;
    border-top: 1px solid ${getPrimitive('blackAlphas.black10')};
    width: calc(100% + 32px);
    margin-inline: -16px;
    padding-inline: 20px;
    ${mobileMedia} {
        gap: 5px;
        width: calc(100% + 20px);
        margin-inline: -10px;
        padding-inline: 10px;
        padding-top: 10px;
    }
`;

export const buttonGroup = styled.div`
    ${dFlex}
    ${justifyCenter}
    gap: 10px;
    &.mobile{
        ${justifyEnd};
        width: 100%;
    }
`;
